import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component, Fragment } from 'react';
import { FieldArray } from '../../../libs/reduxForm';
import LegalRepresentativeFieldGroup from './LegalRepresentativeFieldGroup';
import './FormField.css';

var ArrayComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(ArrayComponent, _Component);

  function ArrayComponent() {
    _classCallCheck(this, ArrayComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArrayComponent).apply(this, arguments));
  }

  _createClass(ArrayComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          fields = _this$props.fields,
          startWithOneItem = _this$props.startWithOneItem;

      if (startWithOneItem && fields.length === 0) {
        fields.push();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          fields = _this$props2.fields,
          AddButton = _this$props2.AddButton,
          RemoveButton = _this$props2.RemoveButton;
      return React.createElement(Fragment, null, fields.map(function (fieldName, index) {
        return React.createElement('div', {
          key: fieldName
        }, React.createElement('h2', {
          className: 'align-items-center'
        }, 'Legal Representative', ' ', index !== 0 && React.createElement(RemoveButton, {
          fields: fields,
          index: index
        })), React.createElement(LegalRepresentativeFieldGroup, {
          name: fieldName
        }));
      }), React.createElement(AddButton, {
        fields: fields
      }));
    }
  }]);

  return ArrayComponent;
}(Component);

var LegalRepresentativeArrayField = function LegalRepresentativeArrayField(_ref) {
  var label = _ref.label,
      name = _ref.name,
      AddButton = _ref.AddButton,
      RemoveButton = _ref.RemoveButton,
      startWithOneItem = _ref.startWithOneItem;
  return React.createElement('div', {
    className: 'form-group'
  }, React.createElement(FieldArray, {
    startWithOneItem: startWithOneItem,
    name: name,
    component: ArrayComponent,
    AddButton: AddButton,
    RemoveButton: RemoveButton
  }));
};

export default LegalRepresentativeArrayField;